<template>
  <v-dialog v-model="showAutoEnrollInfoModal" max-width="600" persistent>
    <v-card class="card-default">
      <v-card-title>
        <!-- <span>Auto Enroll Information</span> -->
        <v-spacer />
        <v-btn icon @click="closeModal">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <div class="main-section">
        <img :src="getImgSrc('green-shield.png')" class="mb-4" />
        <h2 class="mb-5">Auto-Enroll</h2>
        <h3 class="mb-2">What is Auto-Enroll?</h3>

        <p>
          Auto-enroll secures your child's spot in the next course, keeping the same
          class day and time, and often the same instructor and classmates. Without
          Auto-Enroll, you'll need to enroll manually, and if the class fills up, you
          may have to choose a different day or time.
        </p>

        <h3 class="mb-2">Why should I Auto-Enroll?</h3>
        <p>
          Students who progress in the CodeWizardsHQ curriculum without large gaps in
          their schedule don't lose momentum and have higher passing grades and long
          term knowledge retention. That is why we strongly recommend you to turn
          Auto-Enroll ON as it is the only way to ensure consistency and continuity
          in your student's class schedule.
        </p>
      </div>
    </v-card>
  </v-dialog>
</template>

<script setup lang="ts">
import { useMainStore } from '@/stores/mainStore'
import { getImgSrc } from '@/utils/helperFunctions'
import { storeToRefs } from 'pinia'

const { showAutoEnrollInfoModal } = storeToRefs(useMainStore())

function closeModal() {
  showAutoEnrollInfoModal.value = false
}
</script>

<style scoped lang="scss">
.main-section {
  margin-top: -50px;
  padding: 24px;
  text-align: center;
}
</style>
